import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { cardDisbursementApi, verifyDisbursementApi, walletDisbursementApi } from '../../apis/payment';
import { handleApiError } from '../../helpers';
import { LoanStatusId } from '../../interfaces';
import { CardDisbursementDto, VerifyDisbursementDto, WalletDisbursementDto } from '../../interfaces/payment';
import { updateLoanStatus } from '../../states/action_creators/loan.action_creator';

export const useDisburseLoan = () => {
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  const handleVerifyDisbursement = async (payload: VerifyDisbursementDto) => {
    setError(null);
    setProcessing(true);
    try {
      await verifyDisbursementApi(payload);
      setProcessing(false);
      setSuccess(true);
      dispatch(updateLoanStatus(LoanStatusId.ONGOING));
    } catch (error) {
      setError(handleApiError(error));
      setProcessing(false);
    }
  };

  const handleCardDisbursement = async (payload: CardDisbursementDto) => {
    setError(null);
    setProcessing(true);
    try {
      await cardDisbursementApi(payload);
      setProcessing(false);
      setSuccess(true);
      dispatch(updateLoanStatus(LoanStatusId.ONGOING));
    } catch (error) {
      setError(handleApiError(error));
      setProcessing(false);
    }
  };

  const handleWalletDisbursement = async (payload: WalletDisbursementDto) => {
    setError(null);
    setProcessing(true);
    try {
      await walletDisbursementApi(payload);
      setProcessing(false);
      setSuccess(true);
      dispatch(updateLoanStatus(LoanStatusId.ONGOING));
    } catch (error) {
      setError(handleApiError(error));
      setProcessing(false);
    }
  };

  return { processing, error, success, handleVerifyDisbursement, handleCardDisbursement, handleWalletDisbursement };
};
